<template>
  <div class="resetPwd mresetPwd">
    <app-header head-title="找回密码"></app-header>
    <div class="resetPwdPart">
      <div class="banner">
        <div class="title-tips">
          <div class="title-line"></div>
        </div>
        <div class="center">
          <div class="progressBar">
            <div class="progressBarBg" ref="progressBarBg">
              <span class="step-1" :class="{active: step1}">确认账号</span>
              <span class="step-2" :class="{active: step2}">安全验证</span>
              <span class="step-3" :class="{active: step3}">重置密码</span>
              <span class="step-4" :class="{active: step4}">完成</span>
            </div>
          </div>
          <div class="resetPwdDiv" :class="{step2Div:step2} ">
            <el-form
              ref="resetPwdForm"
              :model="resetPwdForm"
              :rules="resetPwdRules"
              autocomplete="on"
            >
              <el-form-item style="margin-bottom:20px"
                prop="account"
                v-show="step1 && !step2 && !step3 && !step4"
                :error="accountErrorMsg"
              >
              <div class="error-code" v-if="captchaError">{{ captchaError }}</div>
                <span class="account-icon"></span>
                <el-input
                  ref="account"
                  v-model.trim="resetPwdForm.account"
                  placeholder="请输入手机号或邮箱账号"
                  name="account"
                  id="username"
                  autocomplete="on"
                  @focus="accountErrorMsg='';captchaError=''"
                />
              </el-form-item>






              <!-- <el-form-item style="margin-bottom:25px"
                class="imgCodeDiv"
                prop="captcha"
                v-show="step1 && !step2 && !step3 && !step4"
                :error="captchaErrorMsg"
              >
                <el-input
                  style="width: 200px;"
                  ref="captcha"
                  placeholder="请输入图形码"
                  name="captcha"
                  maxLength="6"
                  id="usercaptcha"
                  @focus="captchaErrorMsg=''"
                  :value="resetPwdForm.captcha"
                  @input="e => resetPwdForm.captcha = validSe(e)"
                />
                <img
                  ref="imgCode"
                  :src="varHost + 'uc/auth/password/forgot/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="验证码"
                />
              </el-form-item> -->
              









              <div class="step2-div" v-show="step1 && step2 && !step3 && !step4">
                <div class="step2-tips">
                  <p>为了保证账号安全，需要验证{{accountType}}有效性</p>
                  <p class="phoneNum">{{resetPwdForm.account | hiddenPhoneNum}}</p>
                </div>
                <el-form-item class="code" prop="code" :error="codeErrorMsg">
                  <span class="phoneCode-icon"></span>
                  <el-input
                    ref="code"
                    v-model.trim="resetPwdForm.code"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleResetPwd"
                    @focus="codeErrorMsg=''"
                    name="phoneCode"
                    type="tel"
                    maxlength="6"
                  />
                </el-form-item>
                <el-button
                  class="codeBtn"
                  :class="{'is-timing':able}"
                  :disabled="able"
                  type="primary"
                  @click="getCode"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show">{{count}} s</span>
                </el-button>
              </div>
              <div class="step3-div" v-show="step1 && step2 && step3 && !step4">
                <el-form-item prop="password">
                  <el-input
                    ref="password"
                    v-model.trim="resetPwdForm.password"
                    placeholder="请输入新密码"
                    name="password"
                    autocomplete="on"
                    :type="pwdSee?'text':'password'"
                  />
                  <i class="input-icon" :class="{hidden:pwdSee}" @click="showPwd('password')"></i>
                </el-form-item>
                <el-form-item prop="surePassword">
                  <el-input
                    ref="surePassword"
                    v-model.trim="resetPwdForm.surePassword"
                    placeholder="请输入新密码"
                    name="surePassword"
                    autocomplete="off"
                    :type="surePwdSee?'text':'password'"
                  />
                  <i
                    class="input-icon"
                    :class="{hidden:surePwdSee}"
                    @click="showPwd('surePassword')"
                  ></i>
                </el-form-item>
              </div>
              <div class="step4-div" v-show="step1 && step2 && step3 && step4">
                <div class="step4-Bg"></div>
                <p style="font-size:19px;font-weight: 400;color: #4C4C4C;">已重置完成</p>
                <p style="font-size:11px;font-weight: 400;color: #999;">
                  <span class="5sBack">{{timeOut}}s后返回</span>
                </p>
              </div>
            </el-form>
            <el-button
              :loading="loading"
              class="resetPwdBtn"
              type="primary"
              @click.native.prevent="handleResetPwd"
              v-show="!(step1 && step2 && step3 && step4)"
            >{{btnTips}}</el-button>

            <div class="backToLogin" v-show="step1 && !step2 && !step3 && !step4">
              记得密码，
              <span class="toLogin" @click="toLogin">点击登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.resetPwd .el-button.codeBtn {
  font-size: 13px;
  float: right;
  height: 30px;
  margin-top: -76px;
  margin-right: 4px;
  z-index: 100;
  position: relative;
  padding: 0 14px;
  background-color: #2B7FF7;
  color: #fff;
  border-radius: 6px;
}
</style>
<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import { androidFontFn } from "@/utils/androidFont";

export default {
  name: "Regist",
  components: {
    "app-header": header,
    "app-footer": footer
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (
        /^1[3456789]\d{9}$/.test(value) ||
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
          value
        )
      ) {
        if (
          /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
            value
          )
        ) {
          this.accountType = "邮箱";
        }
        callback();
      } else {
        callback(new Error("请输入手机号或邮箱号"));
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入正确的图形码"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        if (
          this.resetPwdForm.password !== this.resetPwdForm.surePassword &&
          this.resetPwdForm.surePassword != ""
        ) {
          callback(new Error("两次密码输入不同"));
        } else {
          callback();
        }
      }
    };
    var validateSureword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        if (this.resetPwdForm.password !== this.resetPwdForm.surePassword) {
          callback(new Error("两次密码输入不同"));
        } else {
          callback();
        }
      }
    };
    return {
      step1: true,
      step2: false,
      step3: false,
      step4: false,
      btnTips: "下一步",
      accountType: "手机",
      timeOut: 5,
      accountErrorMsg: "",
      captchaErrorMsg: "",
      captchaError:"",
      codeErrorMsg: "",
      resetPwdForm: {
        account: "",
        captcha: "",
        code: "",
        password: "",
        surePassword: "",
        ticket: "",
        randstr: ""
      },
      resetPwdRules: {
        account: [
          {
            required: true,
            // message: "请输入手机号或邮箱号",
            trigger: "blur",
            validator: validateAccount
          }
        ],
        captcha: [
          {
            required: true,
            // message: "请输入图形码",
            trigger: "blur",
            validator: validateCaptcha
          }
        ],

        code: [
          {
            required: true,
            // message: "请输入验证码",
            trigger: "blur",
            validator: validateCode
          }
        ],
        password: [
          {
            required: true,
            // message: "请输入新密码",
            trigger: "blur",
            validator: validatePassword
          }
        ],
        surePassword: [
          {
            required: true,
            // message: "请再次输入新密码",
            trigger: "blur",
            validator: validatePassword
          }
        ]
      },
      loading: false,
      pwdSee: false,
      surePwdSee: false,
      show: true,
      count: "",
      timer: null,
      able: false,
      CaptchaAppId: '192261687',
    };
  },
  watch: {
    $route: {}
  },
  computed: {
    // counts() {
    //   console.log(this.$store.state.user.token);
    // }
  },
  created() {},
  mounted() {
    androidFontFn();
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f3f2f0");
  },
  beforeDestroy() {
    // document.querySelector("body").removeAttribute("style");
  },
  methods: {
    validSe(value){
      value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "").replace(/[\u4e00-\u9fa5]/g,'');
      return value;
    },
    getCode(cb) {
      // 发送请求获取验证码
      user
        .getMsgForgot(this.resetPwdForm.account)
        .then(response => {
          // console.log(response);
          this.able = true;
          // 倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                this.able = false;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          cb(this);
        })
        .catch(error => {
          console.log(error);
          this.errorMsgEmpty();
          this.$nextTick(function() {
            typeof error == "string" ? (this.accountErrorMsg = error) : true;
          });
        });
    },
    showPwd(which) {
      which == "password"
        ? (this.pwdSee = !this.pwdSee)
        : (this.surePwdSee = !this.surePwdSee);
      this.$nextTick(() => {
        this.$refs[which].focus();
      });
    },
    toLogin() {
      this.$router.push({ path: "/mlogin" });
    },
    errorMsgEmpty() {
      this.captchaError="";
      this.accountErrorMsg = "";
      this.codeErrorMsg = "";
      this.captchaErrorMsg = "";
    },

    // imgCodeRefresh() {
    //   this.$refs.imgCode.src =
    //     // this.varHost + "uc/auth/password/forgot/captcha?" + Math.random();
    //     this.varHost + "uc/auth/password/forgot/captcha?" + Math.random();
    // },
    getTcaptcha() {
      let _this = this;
      try {
        // 生成一个验证码对象
        let captcha = new TencentCaptcha(this.CaptchaAppId, _this.callback, {});
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback();
      }
    },
    callback(res) {
      // console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        // 验证成功
          this.resetPwdForm.ticket = res.ticket;
          this.resetPwdForm.randstr = res.randstr;
          this.checkCaptchaNewPrev();
      }else if(res.ret === 2){
        this.resetPwdForm.ticket = '';
        this.resetPwdForm.randstr = '';
      }
    },
    loadErrorCallback() {
        let appid = this.CaptchaAppId;
        // 生成容灾票据或自行做其它处理
        let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
        this.callback({
          ret: -1,
          randstr: '@' + Math.random().toString(36).substr(2),
          ticket: ticket,
          errorCode: 1001,
          errorMessage: 'jsload_error'
        });
    },
    checkCaptchaNewPrev() {
      user
        .checkCaptchaNew({
          account: this.resetPwdForm.account,
          // captcha: this.resetPwdForm.captcha,
          step: 'confirm-account',
          captcha_result: {
            ticket: this.resetPwdForm.ticket,
            randstr: this.resetPwdForm.randstr
          }
        })
        .then(result => {

          this.step2 = true;
          this.$refs["progressBarBg"].style.backgroundImage = "url(" + require("../../assets/images/mpwd2.png") + ")";

          this.able = true;
          // 倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                this.able = false;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          // this.$Message.success(result.data.message);
          //   this.loading = true;
          // this.getCode(function(this_) {
          // });
        })
        .catch(error => {
          // console.log(4444,error);

          // this.imgCodeRefresh()
          this.errorMsgEmpty();
          // this.$Message.error(error);

          this.$nextTick(function() {
            // let errorInfo
            // let flag
            if(error){
              if(error == '验证码验证失败'){
                this.captchaError = error
              } else if(error === "手机号不存在" || error === "手机号格式不正确" || error === "邮箱不存在"){
                this.accountErrorMsg = error
              }else if(error === "图形验证码错误"){
                this.captchaErrorMsg = error
              }
              // if(flag){
              //   this.captchaErrorMsg = errorInfo
              // }else{
              //   this.accountErrorMsg = errorInfo
              // }

              // if(!this.accountErrorMsg){
              //   this.accountErrorMsg = error;
              // }
            }
          });
        });
    },
    handleResetPwd() {
      if (!this.step2) {
        this.$refs["resetPwdForm"].validateField("account", error => {
          if (!error) {
            // this.$refs["resetPwdForm"].validateField("captcha", error1 => {
            //   if (!error1) {
            //     user
            //     .checkCaptcha({
            //       account: this.resetPwdForm.account,
            //       captcha: this.resetPwdForm.captcha,
            //       step: 'confirm-account'
            //     })
            //     .then(result => {

            //       this.step2 = true;
            //       this.$refs["progressBarBg"].style.backgroundImage = "url(" + require("../../assets/images/mpwd2.png") + ")";

            //       this.able = true;
            //       // 倒计时
            //       const TIME_COUNT = 60;
            //       if (!this.timer) {
            //         this.count = TIME_COUNT;
            //         this.show = false;
            //         this.timer = setInterval(() => {
            //           if (this.count > 0 && this.count <= TIME_COUNT) {
            //             this.count--;
            //           } else {
            //             this.show = true;
            //             this.able = false;
            //             clearInterval(this.timer);
            //             this.timer = null;
            //           }
            //         }, 1000);
            //       }
            //       // this.$Message.success(result.data.message);
            //       //   this.loading = true;
            //       // this.getCode(function(this_) {
            //       // });
            //     })
            //     .catch(error => {
            //       // console.log(4444,error);

            //       this.imgCodeRefresh()
            //       this.errorMsgEmpty();
            //       // this.$Message.error(error);

            //       this.$nextTick(function() {
            //         let errorInfo
            //         let flag
            //         if(error){
            //           if(error === "手机号不存在" || error === "手机号格式不正确" || error === "邮箱不存在"){
            //             errorInfo = error
            //           }else if(error === "图形验证码错误"){
            //             errorInfo = error
            //             flag = 1
            //           }
            //           if(flag){
            //             this.captchaErrorMsg = errorInfo
            //           }else{
            //             this.accountErrorMsg = errorInfo
            //           }
            //         }
            //       });
            //     });
            //   } else {
            //     return false;
            //   }

            // });

            this.getTcaptcha();
            
          } else {
            return false;
          }
        });
      } else if (!this.step3 && this.step2) {
        this.$refs["resetPwdForm"].validateField("code", error => {
          if (!error) {
            //   this.loading = true;
            user
              .forgotPwdCheck({
                account: this.resetPwdForm.account,
                account_verify_code: this.resetPwdForm.code
              })
              .then(result => {
                // this.$Message.success(result.data.message);
                this.step3 = true;
                this.btnTips = "重置密码";
                this.$refs["progressBarBg"].style.backgroundImage =
                  "url(" + require("../../assets/images/mpwd3.png") + ")";
              })
              .catch(error => {
                console.log(error);
                this.errorMsgEmpty();
                this.$nextTick(function() {
                  typeof error == "string" ? (this.codeErrorMsg = error) : true;
                });
              });
          } else {
            return false;
          }
        });
      } else if (!this.step4 && this.step3) {
        this.$refs["resetPwdForm"].validateField("password", error => {
          if (!error) {
          } else {
            return false;
          }
        });
        this.$refs["resetPwdForm"].validateField("surePassword", error => {
          if (!error) {
            this.loading = true;
            user
              .forgotPwd({
                account: this.resetPwdForm.account,
                password: this.resetPwdForm.password,
                password_confirmation: this.resetPwdForm.surePassword
              })
              .then(result => {
                // console.log(result);
                this.loading = false;
                // this.$Message.success(result.data.message);
                this.step4 = true;
                this.$refs["progressBarBg"].style.backgroundImage =
                  "url(" + require("../../assets/images/mpwd4.png") + ")";
                var clear = setInterval(() => {
                  this.timeOut--;
                }, 1000);
                setTimeout(() => {
                  clearInterval(clear);
                  this.toLogin();
                }, 5000);
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            return false;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
/* reset element-ui css */
html,body,#app{
  width: 100%;
  height: 100%;
}
.resetPwd {
  .el-input {
    display: inline-block;
    height: 42px;

    input {
      border: 0px;
      -webkit-appearance: none;
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      height: 42px;
    }
  }

  .el-form-item {
    background: #fff;
    border-radius: 6px;
    color: #454545;
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
    }
  }

  .el-form-item.code {
    width: 210px;
    margin-top: 22px;
    margin-bottom: 38px;
  }
}
.imgCodeDiv{
  input{
    padding-left: 20px!important;
  }
}
.resetPwd.mresetPwd{
  .el-form-item .el-input__inner{
    padding-top: 0!important;
    padding-bottom: 0!important;
    line-height: 43px!important;
  }
  input::-webkit-input-placeholder{
    font-size: 16px;
    line-height: 43px;
  }    
  input:-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                
  input::-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                  
  input:-ms-input-placeholder{
    line-height: 43px;
    font-size: 16px;
  }          
}
</style>

<style lang="scss" scoped>

.resetPwd {
  background: #f3f2f0 url(../../assets/images/mresetPassword-bg.png) no-repeat top center;
  background-size:100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .imgCodeDiv{
    background: none!important;
    input{
      padding-left: 20px!important;
    }
  }
  .code-img{
    position: absolute;
    right: 0;
    width: 100px;
    height: 45px;
  }
  .headerOuter,.footer{
    display: none;
  }
  >>> .el-input {
    display: inline-block;
    height: 45px;
    input {
      border: 0px;
      -webkit-appearance: none;
      border-radius: 5px;
      padding: 12px 5px 12px 54px;
      height: 45px;
      border: 1px solid #e8e8e8!important;
      position: relative;
    }
    input[name="password"]{
      border-bottom: 0!important;
      border-radius: 5px 5px 0 0!important;
      padding-left: 15px;
    }
    input[name="surePassword"]{
      border-radius: 0 0 5px 5px !important;
      padding-left: 15px;
    }

  }

  >>> .el-form-item {
    background: #fff;
    border-radius: 3px;
    color: #454545;
    margin-bottom: 0px;
    .el-form-item__content{
        height: 45px!important;
        line-height: 45px!important;
      }
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
    }
  }

  >>> .el-form-item.code {
    width: 100%;
    margin-top: 22px;
    margin-bottom: 38px;
  }

  .account-icon,.phoneCode-icon{
    position: absolute;
    left: 20px;
    top: 3px;
    width: 18px;
    height: 39px;
    z-index: 1;
    background: url("../../assets/images/mlogin1.png") no-repeat center;
    background-size: 100%;
  }
  .phoneCode-icon{
    background: url("../../assets/images/mlogin2.png") no-repeat center;
    background-size: 100%;
  }
  .resetPwdPart {
    width: 100%;
    height: 100%;
    //background: url(../../assets/images/RegisterBG.png) repeat-x top;
    position: relative;
    .banner{height: 100%;}
    .title-tips {
      position: absolute;
      top: 90px;
      left: 50%;
      z-index: 101;
      margin-left: -110px;
      width: 220px;
      //height: 50px;
      //background: url(../../assets/images/icons.png) no-repeat -20px -354px;
      .title-line {
        position: absolute;
        bottom: -14px;
        left: 50%;
        z-index: 101;
        margin-left: -40px;
        width: 80px;
        height: 3px;
        background: url(../../assets/images/icons.png) no-repeat -40px -240px;
      }
    }
    .center {
      height: 100%;
      position: relative;
      width: 100%;
      margin: 0 auto;
      .progressBar {
        height: 28px;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        // background: #fff;
        position: absolute;
        top: 180px;
        left: 0;
        margin-left: 0;
        border-radius: 15px;
        overflow: hidden;
        .progressBarBg {
          height: 28px;
          width: 100%;
          margin: 0 auto;
          background:#fff url("../../assets/images/mpwd1.png") no-repeat left center;
          background-size: 100%;
          border-radius: 15px;
          // background: url("../../assets/images/icons.png") -19px -218px;
          // background: url("../../assets/images/icons.png") -19px -256px;
          // background: url("../../assets/images/icons.png") 19px -293px;
          // position: absolute;
          left: 0;
        }
        span {
          width: 25%;
          height: 28px;
          color: #ccc;
          line-height: 28px;
          float: left;
          text-align: center;
          font-style: normal;
          font-size: 11px;
        }
        span.active {
          color: #fff;
        }
      }
    }
    .resetPwdDiv {
      padding: 0 30px;
      box-sizing: border-box;
      width: 100%;
      margin: 0 auto;
      position: absolute;
      top: 270px;
      left: 0;
      // margin-left: -160px;
      .step2-div {
        .step2-tips {
          p {
            color: #999;
            font-size: 13px;
            text-align: center;
            margin: 15px 0;
            font-weight: 400;
          }
          .phoneNum {
            color: #000;
            font-size: 19px;
            font-weight: 400;
            line-height: 25px;
          }
        }
      }
      .step3-div {
        margin-top: 0;
        margin-bottom: 70px;
      }
      .step4-div {
        margin-top: 0;
        .step4-Bg {
          height: 106px;
          width: 106px;
          background: url("../../assets/images/mpwd5.png") no-repeat top;
          background-size: 100%;
          margin:0 auto;
          margin-bottom: 11px;
        }
        p {
          text-align: center;
          margin-bottom: 4px;
        }
      }
    }
    .resetPwdDiv.step2Div {
      top: 242px;
    }
  }

  .resetPwd-form {
    position: relative;
    max-width: 100%;
    padding-top: 200px;
    margin: 0 auto;
    overflow: hidden;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .resetPwdBtn {
    width: 100%;
    height: 45px;
    margin-bottom: 10px;
    background: #4981f2;
    color: #fff;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 400;
    box-shadow: inset 0px -8px 0px 0 #3F79EE,0px 6px 0px 0 #E5E5E5;
  }
  .backToLogin {
    font-size: 13px;
    text-align: center;
    font-weight: 400;
    .toLogin {
      color: #4981F2;
      cursor: pointer;
    }
  }
  .error-code {
    font-size: 12px;
    position: absolute;
    top: 33px;
    z-index: 100;
    color: #f00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mresetPwd/index.vue